/** El asterisco oficial que gira: «ocupado» en las hojas rojas y la tablet (componentes.md §16b). */
export function Asterisco({ tamano = 22 }: { tamano?: number }) {
    return (
        <svg className="rv-ast" viewBox="567.83 535.93 120 120" aria-hidden="true" style={{ width: tamano, height: tamano }}>
            <path d="M613 545H642L638 581L672 567L681 594L646 601L671 627L648 645L627 613L607 645L584 627L610 601L575 594L584 567L617 581Z" />
        </svg>
    );
}
